import React from "react";
import arrowNext from "../../assets/images/arrowNext.png"
import { useHistory } from "react-router-dom";

const CourseResultItem = ({ course }) => {
  let history = useHistory();
  return (
    <div 
      className="course-result-item"
      onClick={(e) => {
        e.preventDefault();
        history.push(`/course_details/${course.id}`)
      }}
    >
      <div className="course-result-image">
        <img 
          src={course.previewUrl} 
          alt="Image"
        />
      </div>
      <div className="course-result-info">
        <div 
          className="course-result-title"
          dangerouslySetInnerHTML={{ __html: course.name }}
        ></div>
        <div 
          className="course-result-desctiption" 
          dangerouslySetInnerHTML={{ __html: course.description }}
        ></div>
      </div>
      <div className="course-result-button">
        <img 
            className="course-result-icon"
            src={arrowNext} 
            alt="Image"
          />
      </div>
    </div>
  );
};
  
export default CourseResultItem;
  